<template>
  <div class="w-full mb-6">
    <div class="w-full">
      <h6 class="mb-3">Dokumen Pendukung Laporan</h6> <br>
      <global-wrapper :loading="fileLoading" :empty="documents.length <= 0" loadingType="twoLine">
        <global-file-upload
          v-for="(item, index) in documents"
          :key="index"
          :item="item"
        >
          <template slot="action">
            <vs-button
              color="primary"
              type="border"
              icon="icon-download"
              icon-pack="feather"
              size="small"
              @click="downloadFile(item.file_url)"
              >Download</vs-button
            >
          </template>
        </global-file-upload> 

        <template #empty>
          <div class="w-full mb-2">Tidak ada dokumen pendukung yang disertakan</div>
        </template>
      </global-wrapper><br>
    </div>
  </div>
</template>
<script>
import LoadingDialog from "@/components/dialog/LoadingDialog";

export default {
  components: {
    LoadingDialog
  },
  props: {
    whistleblower: {
      type: Object
    }
  },
  data() {
    return {
      fileLoading: false,
      progress: 0,
      responseValue: []
    };
  },
  computed: {
    documents() {
      return this.whistleblower.dokumen.filter(data => {
        return data.tipe == "whistleblower"
      });
    },
  },
  methods: {
    downloadFile(url) {
      window.open(url);
    },
    submitCallback() {
      this.$emit("submitCallback");
    }
  }
};
</script>
